
import * as vercelRuntime$b8uWPRx1qM from '/vercel/path0/node_modules/@nuxt/image/dist/runtime/providers/vercel'

export const imageOptions = {
  "screens": {
    "xs": 420,
    "sm": 640,
    "md": 768,
    "lg": 1080,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1440
  },
  "presets": {},
  "provider": "vercel",
  "domains": [
    "cncenter.codexcdn.net",
    "data.eu.cntmbr.com",
    "mama.pigy.cz"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ],
  "quality": 80
}

imageOptions.providers = {
  ['vercel']: { provider: vercelRuntime$b8uWPRx1qM, defaults: {} }
}
        